import React from 'react';
import { Helmet } from 'react-helmet-async';
import TabsMAIQ from 'app/components/TabsMAIQ';
import { PageContainer, PageHeader } from 'app/components/StyledComponents';
import { BreadcrumbsComponent } from 'app/components/BreadcrumbsComponent';

import GenerateTab from './Tabs/Generate/GenerateTab';
import TargetTab from './Tabs/Target/TargetTab';
import ConfigureTab from './Tabs/AutoPilot/AutopilotTab';
import MeasureTab from './Tabs/Measure/MeasureTab';
import { Box } from '@mui/material';
import { MCPProvider } from '../contexts/MCPContext';
import { MiaChatV2Provider } from 'app/context/MiaChatV2Context';
import { useSelector } from 'react-redux';
import { selectDealerSelected } from '../../Header/selectors';

const V2MiaChatPage: React.FC = () => {
  const selectedDealer = useSelector(selectDealerSelected);
  
  const tabsData = [
    {
      label: 'GENERATE',
      content: <GenerateTab />,
    },
    {
      label: 'TARGET',
      content: <TargetTab />,
    },
    {
      label: 'CONFIGURE',
      content: <ConfigureTab />,
    },
    {
      label: 'MEASURE',
      content: <MeasureTab />,
    },
  ];

  const breadcrumbsList = [
    { label: 'MIA Chat V2', isActive: true }
  ];

  return (
    <MiaChatV2Provider>
      {/* <MCPProvider dealership={selectedDealer}> */}
        <Helmet>
          <title>MIA Chat V2 - AI-Powered Email Campaigns</title>
          <meta name="description" content="Generate, target, automate, and measure AI-powered email campaigns for your dealership" />
        </Helmet>
        

        <PageContainer sx={{ 
          // background: 'linear-gradient(135deg,rgb(255, 255, 255) 0%,rgb(255, 255, 255) 50%,rgb(203, 203, 203) 100%)', 
          padding: '0px' }}
        >
          <Box sx={{ padding: '40px' }}>
            <BreadcrumbsComponent breadcrumbsList={breadcrumbsList} />
            <PageHeader>MIA Chat V2</PageHeader>
          </Box>
          <TabsMAIQ tabs={tabsData} />
        </PageContainer>
      {/* </MCPProvider> */}
    </MiaChatV2Provider>
  );
};

export default V2MiaChatPage;